import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const NoSpendingMessage = () => {
  return (
    <Box alignItems="center" textAlign="center" gap="s8" maxWidth="s600" paddingX="s24">
      <Icon.Large icon="money-bag" />
      <Text weight="medium" size="400" color="grey1000">
        {i18n.t('project_management.spending.table.no_spending_message.title')}
      </Text>
      <Text weight="normal" size="300" color="grey800">
        {i18n.t('project_management.spending.table.no_spending_message.description')}
      </Text>
    </Box>
  )
}

export default NoSpendingMessage
